import { Button } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { ComplianceExtraFieldsConfigFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { DefaultComplianceSettingsForm } from './DefaultComplianceSettingsForm'
import { DefaultComplianceSettingsFormValues } from './types'

interface DefaultComplianceSettingsModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void
  title: string
  description: string
  submitButtonText: string
  form: FormikProps<DefaultComplianceSettingsFormValues>
  systemComplianceExtraFields: ComplianceExtraFieldsConfigFragment[]
  loading?: boolean
  submitting?: boolean
  isUpdate?: boolean
}

export const DefaultComplianceSettingsModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  description,
  submitButtonText,
  form,
  systemComplianceExtraFields,
  loading = false,
  submitting = false,
  isUpdate = false,
}: DefaultComplianceSettingsModalProps) => {
  if (!isOpen) return null

  return (
    <Modal
      illustration="template"
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={loading || submitting}>
            {submitButtonText}
          </Button>
        </>
      }
    >
      <DefaultComplianceSettingsForm
        form={form}
        systemComplianceExtraFields={systemComplianceExtraFields}
        isUpdate={isUpdate}
      />
    </Modal>
  )
}
